import React from 'react'

import { Bars2Icon } from '@heroicons/react/20/solid'
import { Draggable } from 'react-beautiful-dnd'

import { TaskItemProps } from '@/features/SidePanel/TaskItem'

export type TaskBaseItemProps = TaskItemProps & {
  children: React.ReactNode
  extraSlot?: React.ReactNode
  lastItem?: boolean
  draggableDisabled?: boolean
}

export const TaskBaseItemV2 = (props: TaskBaseItemProps) => {
  const { children, task, index, draggableDisabled, extraSlot = null, lastItem } = props

  const containerClasses = `px-4 py-5 border-b justify-between bg-white ${
    lastItem ? 'rounded-b-box' : ''
  }`

  return (
    <Draggable
      draggableId={task.uuid}
      index={index}
      isDragDisabled={draggableDisabled}
    >
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={containerClasses}
          style={{ ...provided.draggableProps.style }}
        >
          <div className='flex gap-2 3xl:gap-5'>{children}</div>
          {extraSlot}
        </div>
      )}
    </Draggable>
  )
}
